/** Generated from EFindingBlacklistType.java. Do not modify this file! */


export type EFindingBlacklistTypeEntry = 'FALSE_POSITIVE' | 'TOLERATION';

export class EFindingBlacklistType {
	static readonly FALSE_POSITIVE = new EFindingBlacklistType(0, 'FALSE_POSITIVE', "False Positive");
	static readonly TOLERATION = new EFindingBlacklistType(1, 'TOLERATION', "Toleration");
	static readonly values = [
		EFindingBlacklistType.FALSE_POSITIVE,
		EFindingBlacklistType.TOLERATION
	];



	private constructor (
		public readonly ordinal: number,
		public readonly name: EFindingBlacklistTypeEntry,
		public readonly readableName: string
	){
	}

	toString() {
		return this.name;
	}

	/** Returns the enum value of the provided enum entry. */
	public static valueOf(entry: EFindingBlacklistTypeEntry): EFindingBlacklistType;
	/** Returns the enum value of the provided enum entry. Returns undefined if entry was undefined. */
	public static valueOf(entry: EFindingBlacklistTypeEntry | undefined): EFindingBlacklistType | undefined;
	public static valueOf(entry: EFindingBlacklistTypeEntry | undefined): EFindingBlacklistType | undefined {
		if (entry === undefined) {
			return undefined;
		}
		return EFindingBlacklistType[entry];
	}
}

